module.exports = __webpack_public_path__ + "media/categories/6010-0a73e2b3.svg";